<template>
  <v-card class="bi-cohorts-filter pa-2">
    <v-row class="mx-0 justify-space-between">
      <v-col cols="4">
        <v-row>
          <v-autocomplete
            v-model="affiliate"
            label="Affiliate"
            :items="affiliates"
            :loading="isLoadingAffiliates"
            hide-details
          />
        </v-row>
        <v-row style="gap: 1rem;">
          <v-select
            v-model="projectId"
            label="Project"
            :items="entities"
            hide-details
            @change="$emit('request-affiliates', $event)"
          />
          <v-autocomplete
            v-model="geo"
            label="Geo"
            item-value="code"
            item-text="title"
            :items="$store.state.app.countries"
            multiple
            auto-select-first
          />
        </v-row>
      </v-col>
      <v-col cols="4">
        <v-select
          :items="dateRangeList"
          label="FTD Period"
          @change="changeTimePeriod"
          hide-details
          class="px-2 pb-3"
          style="min-width: 150px; width: 50%;"
        />
        <v-row class="mx-0 d-flex justify-space-between flex-grow-1 date-row" style="gap: 1rem;">
          <date-picker
            v-model="from"
            label="FTD From"
          />
          <date-picker
            v-model="to"
            label="FTD To"
          />
        </v-row>
      </v-col>
    </v-row>

    <v-divider />
    <v-row>
      <v-col cols="2">
        <v-select
          v-model="cohortBy"
          label="Cohort by"
          :items="cohortByOptions"
        />
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="sortBy"
          label="Sort by"
          :items="sortByOptions"
        />
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="groupBy"
          label="Group period by"
          :items="groupByOptions"
        />
      </v-col>
    </v-row>
    <v-row class="align-center justify-end">
      <v-col cols="1">
        <v-btn
          v-text="'Create Report'"
          color="primary"
          @click="requestReport"
        />
      </v-col>
    </v-row>

    <v-icon
      color="primary"
      style="position: absolute; top: 1rem; right: 1rem;"
      @click="$emit('show-help')"
    >
      help
    </v-icon>
  </v-card>
</template>

<script>
import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

export default {
  components: {
    DatePicker
  },
  props: {
    isLoading: Boolean,
    isLoadingAffiliates: Boolean,
    entities: {
      type: Array,
      default: () => ([])
    },
    affiliates: {
      type: Array,
      default: () => ([])
    }
  },

  data() {
    return {
      groupBy: 'days',
      cohortBy: 'day',
      sortBy: 'date',
      from: null,
      to: null,
      geo: null,
      projectId: null,
      affiliate: null,
      dateRangeList: dateRangeList.slice(2),
      cohortByOptions: [{
        text: 'Day',
        value: 'day'
      },{
        text: 'Week',
        value: 'week'
      },{
        text: 'Geo',
        value: 'geo'
      },{
        text: 'Affiliate',
        value: 'affiliate'
      }],
      sortByOptions: [{
        text: 'Date',
        value: 'date'
      },{
        text: 'FTD',
        value: 'ftd'
      },{
        text: 'Lifetime',
        value: 'lifetime'
      }],
      groupByOptions: [{
        text: 'Day',
        value: 'days'
      },{
        text: 'Week',
        value: 'weeks'
      },{
        text: 'Deposit',
        value: 'deposit'
      }],
    }
  },

  methods: {
    changeTimePeriod(value) {
      this.from = value.from
      this.to = value.to
    },
    requestReport() {
      const params = {
        groupBy: this.groupBy,
        cohortBy: this.cohortBy,
        sortBy: this.sortBy,
        geo: this.geo,
        to: this.to,
        from: this.from,
        affiliate: this.affiliate,
        projectId: this.projectId,
      }

      this.$emit('request-report', params)
    }
  }
}
</script>

<style scoped lang="scss">
  .date-row > * {
    flex: 1 1 0 !important;
    max-width: 100% !important;
  }
</style>
